import React, { useEffect, useState } from 'react'
import { getCurrentUser, fetchAuthSession } from '@aws-amplify/auth'
import ApiService from '../../ApiService'
import { useHistory } from 'react-router-dom'
import url from '../../util/routeURL'
import RegisterKitModal from './RegisterKitModal'
import CircularProgress from '@material-ui/core/CircularProgress'
import RemoveCSS from '../../util/RemoveCSS'
import './style.css'

const PortalLogin = () => {
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState(null)
  const [newMessages, setNewMessages] = useState(0)
  const [appointments, setAppointments] = useState(null)
  const [show, setShow] = useState(false)
  const [noGenderAtBirth, setNoGenderAtBirth] = useState(false)
  const [patientProfile, setPatientProfile] = useState(null)
  const history = useHistory()

  const handleClose = () => setShow(false)

  useEffect(() => {
    RemoveCSS()
    document.body.classList.add('body_portal')
  }, [])

  useEffect(() => {
    async function initializeDashboard() {
      try {
        const user = await getCurrentUser()
        await fetchAuthSession()
        if (!user) {
          setLoading(false)
          return
        }

        setUser(user)

        const [getMessageCount, patientRes] = await Promise.all([ApiService.getMessageCount(), ApiService.getPatientAfterSessRef()])

        let newMessages = getMessageCount.data
        if (newMessages >= 1) {
          setNewMessages(newMessages)
        }

        const profile = patientRes.data
        setPatientProfile(profile)
        setNoGenderAtBirth(!profile?.genderAtBirth || !profile?.pronoun || !profile?.currentGenderIdentity || !profile?.medication)
      } catch (ex) {
        console.error(ex)
      } finally {
        setLoading(false)
      }
    }

    initializeDashboard()
  }, [])

  if (user) {
    return (
      <div id="user_dashboard" className="panel-default mw-100 mh-100">
        {noGenderAtBirth && (
          <div
            role="alert"
            style={{
              display: 'block',
              alignItems: 'center',
              backgroundColor: '#fff4e5',
              textAlign: 'center',
              color: '#663c00',
              padding: '16px 20px',
              borderLeft: '6px solid #ffcc80',
              borderRight: '6px solid #ffcc80',
              borderRadius: '4px',
              marginBottom: '24px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              fontSize: '18px',
              fontWeight: '500',
              marginTop: '32px',
              // marginLeft: '10px',
              // marginRight: '10px',
            }}
          >
            <span style={{ marginRight: 12, fontSize: '18px' }}>⚠️</span>
            Hi there! It looks like your TBD Health patient profile is incomplete. Please complete it to prevent any delays in care. <br />
            <a
              onClick={() => history.push(url.healthProfile)}
              style={{
                color: '#663c00',
                textDecoration: 'underline',
                fontWeight: '600',
                margin: '0 4px',
                cursor: 'pointer',
              }}
            >
              Click here to update your profile.
            </a>
          </div>
        )}
          <div className="panel-body z-1">
            <div className="panel_header_container">
              <div className="panel-header">Welcome {user?.attributes?.given_name}</div>
              <p className="header-sub">We're here to help</p>
            </div>

          <RegisterKitModal handleClose={handleClose} show={show} goTo={() => history.push(url.registerkit)} />

          <div className="dashboard">
            {loading && <CircularProgress className="loading-button-spinner" />}
            {!loading && (
              <div className="dashboard_panel dash_buttons">
                <>
                  <button id="message-button" className="panel_text new_message_button" onClick={() => history.push(url.inbox)}>
                    {newMessages > 0 ? `${newMessages} Messages` : `Messages`}
                  </button>
                  <button disabled id="appointment-button" className="panel_text panel_button" onClick={() => history.push(url.appointments)}>
                    {appointments} Appointments
                  </button>
                  <button id="history-button" className="panel_text panel_button" onClick={() => history.push(url.history)}>
                    History
                  </button>
                  <button id="settings-button" className="panel_text panel_button" onClick={() => history.push(url.setting)}>
                    Settings
                  </button>
                </>
              </div>
            )}
          </div>
        </div>
        <div className="curved-welcome">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 219">
            <path
              fill="rgba(238, 129, 85, 0.3)"
              fillOpacity="1"
              d="M0,64L120,96C240,128,480,192,720,181.3C960,171,1200,85,1320,42.7L1440,0L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
            ></path>
          </svg>
        </div>
      </div>
    )
  } else {
    return null
  }
}

export default PortalLogin
